import { useCallback, useState } from "react";

export const useBoolean = (
  initialValue = false
): [boolean, () => void, () => void] => {
  const [value, setValue] = useState(initialValue);

  const turnOn = useCallback(() => {
    setValue(true);
  }, []);

  const turnOff = useCallback(() => {
    setValue(false);
  }, []);

  return [value, turnOn, turnOff] as const;
};
